import { useBankProfile } from '@contexts/BankProfileContext';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import type { PaginationQuery, ResponseList } from 'types/response';
import type { TemplateItemResponse } from 'types/templates';

import { useAuth } from './useAuth';

export const useTemplates = (params: PaginationQuery = {}) => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const getTemplates = async () => {
		const response = await axios.get<ResponseList<TemplateItemResponse>>(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/payment-templates`,
			{
				headers: { Authorization: session?.tokenized },
				params,
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: [
			'templates',
			selectedProfile?.id,
			params.page,
			params.per_page,
			session?.tokenized,
		],
		queryFn: getTemplates,
		enabled: !!session?.tokenized && !!selectedProfile?.id,
	});
};
